import React from 'react'
import PropTypes from 'prop-types'

import { FlexColumn, LightBGContainer } from '../styles/Containers'
import { BoldFormTitle, BoldSpan } from '../styles/Text'
import { WarningMessage } from '../common/UserMessage'
import ResponseMessage from './ResponseMessage'
import FinalDocuments from '../common/FinalDocuments'
import foiAccessMethod, { ACCESS_METHOD_TYPE } from '../../util/foiAccessMethod'

function ResponseTab({
  foiId,
  view,
  responseFiles = [],
  letters = [],
  finalResponseLetterId = '',
  responseAttachment,
  accessMethod = 'DIGITAL',
  accessMethodConfig,
  handleLettersUpdated = () => {},
  handleUpdateResponseFiles = () => {}
}) {
  const deliveryWarning = foiAccessMethod.getDeliveryWarningPresentation(accessMethod, accessMethodConfig)

  return (
    <FlexColumn gap="15px">
      {deliveryWarning && (
        <WarningMessage>
          {view === 'editable' ? (
            <div>
              The requestor selected “<BoldSpan>{deliveryWarning.label}</BoldSpan>”. {deliveryWarning.editableInstruction}
            </div>
          ) : (
            <div>
              The requestor selected “<BoldSpan>{deliveryWarning.label}</BoldSpan>” for their access method. {deliveryWarning.completedInstruction}
            </div>
          )}
        </WarningMessage>
      )}
      <LightBGContainer padding="25px 30px 30px">
        <ResponseMessage
          foiId={foiId}
          letters={letters}
          finalResponseLetterId={finalResponseLetterId}
          responseAttachment={responseAttachment}
          view={view}
          accessMethod={accessMethod}
          onLettersUpdated={handleLettersUpdated}
        />
      </LightBGContainer>
      <LightBGContainer padding="30px">
        <FlexColumn gap="10px">
          <BoldFormTitle>Final Documents</BoldFormTitle>
          <FinalDocuments
            requestType="foi"
            requestId={foiId}
            fileList={responseFiles}
            updateFileList={handleUpdateResponseFiles}
            editable={view === 'editable'}
          />
        </FlexColumn>
      </LightBGContainer>
    </FlexColumn>
  )
}

ResponseTab.propTypes = {
  foiId: PropTypes.string.isRequired,
  view: PropTypes.oneOf(['completed', 'editable']).isRequired,
  responseFiles: PropTypes.array,
  letters: PropTypes.array,
  finalResponseLetterId: PropTypes.string,
  responseAttachment: PropTypes.object,
  accessMethod: PropTypes.oneOf(Object.values(ACCESS_METHOD_TYPE)),
  accessMethodConfig: PropTypes.shape({
    digitalLabel: PropTypes.string,
    physicalLabel: PropTypes.string,
    otherActiveType: PropTypes.shape({
      type: PropTypes.oneOf([ACCESS_METHOD_TYPE.OTHER_DIGITAL, ACCESS_METHOD_TYPE.OTHER_PHYSICAL, ACCESS_METHOD_TYPE.OTHER_PICKUP]).isRequired,
      label: PropTypes.string.isRequired,
      pricingDetails: PropTypes.string
    })
  }),
  handleLettersUpdated: PropTypes.func,
  handleUpdateResponseFiles: PropTypes.func
}

export default ResponseTab
